import React from "react";
import Tippy from "@tippyjs/react";
import { useSelector } from "react-redux";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';

const TodoItems = ({
  id,
  row,
  i,
  todoList,
  arrayHelpers,
  activeTodo,
  setActiveTodo,
  deptWithUser,
  setDeletedConfiguration
}) => {
  const { allActivityList } = useSelector((state) => state.assignmentReducer);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const getTeamLabel = () => {
    let label = "";
    if(row.department_id){
      const dept = deptWithUser?.departments?.find(item => item.value === row.department_id)
      if(dept) label = dept.label;
    }else if(row.collaborator_id){
      const collaborator = deptWithUser.collaborators.find(item => item.value === row.collaborator_id);
      if(collaborator) label = collaborator.type;
    }

    return label;
  }

  const getUserLabel = () => {
    let label = "";
    if(row.department_id){
      const dept = deptWithUser?.departments?.find(item => item.value === row.department_id)
      if(dept){
        label = row?.user_id ? dept?.user_departments?.find(item => item.value === row.user_id)?.label || "" : "";
      }
    }else if(row.collaborator_id){
      const collaborator = deptWithUser.collaborators.find(item => item.value === row.collaborator_id);
      if(collaborator){
        label = collaborator.label
      }
    }

    return label ? ` - ${label}` : label;
  }

  const getTodoLabel = (todo_id) => {
    const todoItem = todoList.find(item => item.value === todo_id)
    return todoItem?.label ? todoItem.label : "";
  }

  const getComponentLabel = (todo_id, custom_field_id) => {
    let label = "";
    const todoItem = allActivityList.find(item => item.id === todo_id)
    if(todoItem){
      let value = todoItem?.activitycustomfields?.find(item => item.id === custom_field_id);
      if(value) {
        label = `– ${value?.todo_component?.label || ""} `;
      } else {
        label = "is performed"
      }
    }
    return label;
  }

  const getDependentComponentValues = (todo_id) => {
    let label = JSON.parse(row?.dependent_todo_custom_field_value || '[]');
    return label.join(" or ");
  }

  const style = {
    transform: CSS.Transform?.toString(transform),
    transition,
  };

  return (
    <div
      className={`w-full flex flex-row items-center space-x-4 transition-all ${isDragging ? 'opacity-50' : ''}`}
      ref={setNodeRef}
      style={style}
    >
      <div>
        <span
          {...attributes}
          {...listeners}
          class="fa-regular fa-bars text-base active:cursor-grabbing text-[#9CA3AF]"
          aria-hidden="true"
        ></span>
      </div>
      <div className={`w-full ${ activeTodo === i ? "bg-[--bg-color-500]" : "bg-[--bg-color-50]"} py-2 px-4 rounded flex flex-row items-center justify-between cursor-pointer`}
        onClick={(e) => {
          e.stopPropagation();
          if(parseInt(activeTodo) === parseInt(i)){
            setActiveTodo(null);
          }else{
            setActiveTodo(i);
          }
        }}
      >
        <div className="flex flex-row items-center space-x-2">
        <p className={`font-inter font-semibold text-sm ${ activeTodo === i ? "text-white" : "text-[#1E293B]"} `}>
          {row?.activity_id?.label}
        </p>
        <hr
          className={`block w-px h-6 bg-[#1E293B]`}
        />
        <p className={`font-inter font-semibold text-sm capitalize ${ activeTodo === i ? "text-white" : "text-[#1E293B]"} `}>
          <span className={`font-inter font-semibold font-sm ${ activeTodo === i ? "text-white" : "text-[--bg-color-500]"} `}>@{getTeamLabel()}</span><span className={`font-inter font-normal font-sm ${ activeTodo === i ? "text-white" : "text-[--bg-color-500]"} `}>{getUserLabel()}</span>
        </p>
        </div>
        <div className="flex flex-row items-center space-x-3">
          <Tippy content="Mandatory Todo">
            <span className={`fas fa-asterisk text-sm ${ row?.is_mandatory ? "text-[--bg-color-500]" : "opacity-20" }`} aria-hidden="true"></span>
          </Tippy>
          <Tippy content={`The end date is +${row.duration} hours after ${getTodoLabel(row?.link_activity)} ${getComponentLabel(row?.link_activity, row.activity_customfields_id)}.`} disabled={!row?.link_activity}>
            <span
              className={`fas fa-link text-sm ${ row?.link_activity ? "text-[--bg-color-500]" : "opacity-20" }`}
              aria-hidden="true"
            ></span>
          </Tippy>
          <Tippy content={`Completes once ${getTodoLabel(row?.loop_activity)} is completed.`} disabled={!row?.loop_activity}>
            <span
              className={`fas fa-infinity text-sm ${ row?.loop_activity ? "text-[--bg-color-500]" : "opacity-20" }`}
              aria-hidden="true"
            ></span>
          </Tippy>
          <Tippy content={`Activated if ${getTodoLabel(row?.dependent_todo)} ${getComponentLabel(row?.dependent_todo, row.dependent_todo_custom_field_id)} = ${getDependentComponentValues()}`} disabled={!row?.dependent_todo}>
            <span
              className={`fa-regular fa-link-simple text-sm ${ row?.dependent_todo ? "text-[--bg-color-500]" : "opacity-20" }`}
              aria-hidden="true"
            ></span>
          </Tippy>
        </div>
      </div>
      <div title="Delete">
        <span
          className="fa-light fa-trash-can text-base cursor-pointer"
          aria-hidden="true"
          style={{ color: "rgb(235, 87, 87)" }}
          onClick={(e) => {
            if(row.configuration_setting_mapping_id){
              setDeletedConfiguration(prev => [...prev, row.configuration_setting_mapping_id])
            }
            e.stopPropagation();
            arrayHelpers.remove(i)
          }}
        ></span>
      </div>
    </div>
  );
};

export default TodoItems;
